import { shouldShowPage } from '../../utils/permissionControl';
import { buildMembersTab } from './membersTabs';
import { buildPermissionsTab } from './permissionsTabs';
import { buildSystemSettingsTab } from './systemSettingsTabs';
import { buildToolsTab } from './toolsTab';
import { buildAnnouncementsTab } from './announcementsTab';
import { buildConversionHistoryTab } from './conversionHistoryTab';
import { buildProductLayersTab } from './productLayersTab';

/** 按权限组装管理后台 Tabs items（行为与原 AdminPanel.generateTabs 一致） */
export function buildAdminPanelTabs(ctx) {
  const tabs = [];

  const toolsTab = buildToolsTab({
    shouldShowPage,
    toolName: ctx.toolName,
    setToolName: ctx.setToolName,
    toolUrl: ctx.toolUrl,
    setToolUrl: ctx.setToolUrl,
    toolDescription: ctx.toolDescription,
    setToolDescription: ctx.setToolDescription,
    toolAudience: ctx.toolAudience,
    setToolAudience: ctx.setToolAudience,
    toolGroupIds: ctx.toolGroupIds,
    setToolGroupIds: ctx.setToolGroupIds,
    editId: ctx.editId,
    editBuiltin: ctx.editBuiltin,
    editMobileRelease: ctx.editMobileRelease,
    toolVersionName: ctx.toolVersionName,
    setToolVersionName: ctx.setToolVersionName,
    toolVersionCode: ctx.toolVersionCode,
    setToolVersionCode: ctx.setToolVersionCode,
    resetToolForm: ctx.resetToolForm,
    handleSaveTool: ctx.handleSaveTool,
    handleUpdateToolAccess: ctx.handleUpdateToolAccess,
    handleUploadToolFile: ctx.handleUploadToolFile,
    toolUploading: ctx.toolUploading,
    toolMsg: ctx.toolMsg,
    tools: ctx.tools,
    groups: ctx.groups,
    handleEditTool: ctx.handleEditTool,
    handleDeleteTool: ctx.handleDeleteTool
  });
  if (toolsTab) tabs.push(toolsTab);

  const membersTab = buildMembersTab({
    shouldShowPage,
    userSearch: ctx.userSearch,
    setUserSearch: ctx.setUserSearch,
    handleAddUser: ctx.handleAddUser,
    users: ctx.users,
    selectedUserKeys: ctx.selectedUserKeys,
    setSelectedUserKeys: ctx.setSelectedUserKeys,
    userPermissions: ctx.userPermissions,
    handleEditUser: ctx.handleEditUser,
    handleDeleteUser: ctx.handleDeleteUser,
    handleResetPwd: ctx.handleResetPwd,
    userModalVisible: ctx.userModalVisible,
    setUserModalVisible: ctx.setUserModalVisible,
    userForm: ctx.userForm,
    editingUser: ctx.editingUser,
    handleSaveUser: ctx.handleSaveUser,
    apiRequest: ctx.apiRequest,
    currentUserRole: ctx.currentUserRole,
    brandingScopeModalVisible: ctx.brandingScopeModalVisible,
    brandingScopeUserId: ctx.brandingScopeUserId,
    brandingScopeUserName: ctx.brandingScopeUserName,
    openBrandingScopeModal: ctx.openBrandingScopeModal,
    closeBrandingScopeModal: ctx.closeBrandingScopeModal,
    memberSearch: ctx.memberSearch,
    setMemberSearch: ctx.setMemberSearch,
    setMemberModalVisible: ctx.setMemberModalVisible,
    fetchMembers: ctx.fetchMembers,
    memberMsg: ctx.memberMsg,
    members: ctx.members,
    selectedMemberKeys: ctx.selectedMemberKeys,
    setSelectedMemberKeys: ctx.setSelectedMemberKeys,
    memberPagination: ctx.memberPagination,
    setMemberPagination: ctx.setMemberPagination,
    handleEditMember: ctx.handleEditMember,
    handleDeleteMember: ctx.handleDeleteMember,
    handleBatchDeleteMember: ctx.handleBatchDeleteMember,
    handleBatchDeleteLocation: ctx.handleBatchDeleteLocation,
    handleExportTrack: ctx.handleExportTrack,
    openBatchIconModal: ctx.openBatchIconModal,
    setExportModal: ctx.setExportModal,
    exportModal: ctx.exportModal,
    batchIconModal: ctx.batchIconModal,
    setBatchIconModal: ctx.setBatchIconModal,
    submitBatchSetIcon: ctx.submitBatchSetIcon,
    memberModalVisible: ctx.memberModalVisible,
    memberForm: ctx.memberForm,
    handleSaveMember: ctx.handleSaveMember,
    memberEditModalVisible: ctx.memberEditModalVisible,
    setMemberEditModalVisible: ctx.setMemberEditModalVisible,
    memberEditForm: ctx.memberEditForm,
    handleUpdateMember: ctx.handleUpdateMember,
    organizations: ctx.organizations,
    orgInterconnect: ctx.orgInterconnect,
    handleToggleOrgInterconnect: ctx.handleToggleOrgInterconnect,
    memberOrgFilter: ctx.memberOrgFilter,
    setMemberOrgFilter: ctx.setMemberOrgFilter,
    memberGroupFilter: ctx.memberGroupFilter,
    setMemberGroupFilter: ctx.setMemberGroupFilter,
    handleAddOrg: ctx.handleAddOrg,
    handleRenameOrg: ctx.handleRenameOrg,
    handleDeleteOrgModal: ctx.handleDeleteOrgModal,
    handleAddGroupOrg: ctx.handleAddGroupOrg,
    handleRenameGroupOrg: ctx.handleRenameGroupOrg,
    handleDeleteGroupOrg: ctx.handleDeleteGroupOrg
  });
  if (membersTab) tabs.push(membersTab);

  const permissionsTab = buildPermissionsTab({
    shouldShowPage,
    groupSearch: ctx.groupSearch,
    setGroupSearch: ctx.setGroupSearch,
    handleAddGroup: ctx.handleAddGroup,
    groups: ctx.groups,
    selectedGroupKeys: ctx.selectedGroupKeys,
    setSelectedGroupKeys: ctx.setSelectedGroupKeys,
    handleMoveGroup: ctx.handleMoveGroup,
    handleEditGroup: ctx.handleEditGroup,
    handleDeleteGroup: ctx.handleDeleteGroup,
    fetchGroupAuthPerms: ctx.fetchGroupAuthPerms,
    groupModalVisible: ctx.groupModalVisible,
    setGroupModalVisible: ctx.setGroupModalVisible,
    groupForm: ctx.groupForm,
    editingGroup: ctx.editingGroup,
    handleSaveGroup: ctx.handleSaveGroup,
    groupAuthId: ctx.groupAuthId,
    setGroupAuthId: ctx.setGroupAuthId,
    handleSaveGroupAuth: ctx.handleSaveGroupAuth,
    permissions: ctx.permissions,
    groupAuthPerms: ctx.groupAuthPerms,
    setGroupAuthPerms: ctx.setGroupAuthPerms,
    groupAuthMsg: ctx.groupAuthMsg,
    permSearch: ctx.permSearch,
    setPermSearch: ctx.setPermSearch,
    editingPerm: ctx.editingPerm,
    setEditingPerm: ctx.setEditingPerm,
    permForm: ctx.permForm,
    setPermModalVisible: ctx.setPermModalVisible,
    permModalVisible: ctx.permModalVisible,
    handleSavePerm: ctx.handleSavePerm,
    handleEditPerm: ctx.handleEditPerm,
    handleDeletePerm: ctx.handleDeletePerm,
    users: ctx.users,
    fetchUserAuthGroups: ctx.fetchUserAuthGroups,
    userAuthId: ctx.userAuthId,
    userAuthGroups: ctx.userAuthGroups,
    setUserAuthGroups: ctx.setUserAuthGroups,
    handleSaveUserAuth: ctx.handleSaveUserAuth,
    userAuthMsg: ctx.userAuthMsg,
    userPerms: ctx.userPerms,
    fetchPermissionPreview: ctx.fetchPermissionPreview,
    permissionPreview: ctx.permissionPreview,
    permissionPreviewUserId: ctx.permissionPreviewUserId,
    setPermissionPreviewUserId: ctx.setPermissionPreviewUserId,
    // 队员可见范围配置
    memberScopeModalVisible: ctx.memberScopeModalVisible,
    memberScopeUserId: ctx.memberScopeUserId,
    memberScopeUserName: ctx.memberScopeUserName,
    openMemberScopeModal: ctx.openMemberScopeModal,
    closeMemberScopeModal: ctx.closeMemberScopeModal,
    apiRequest: ctx.apiRequest
  });
  if (permissionsTab) tabs.push(permissionsTab);

  const announcementsTab = buildAnnouncementsTab({
    shouldShowPage,
    setEditingAnn: ctx.setEditingAnn,
    announcementForm: ctx.announcementForm,
    setAnnModalVisible: ctx.setAnnModalVisible,
    announcements: ctx.announcements,
    handleEditAnn: ctx.handleEditAnn,
    handleDeleteAnn: ctx.handleDeleteAnn,
    annModalVisible: ctx.annModalVisible,
    editingAnn: ctx.editingAnn,
    handleSaveAnn: ctx.handleSaveAnn
  });
  if (announcementsTab) tabs.push(announcementsTab);

  const conversionHistoryTab = buildConversionHistoryTab({
    shouldShowPage,
    apiRequest: ctx.apiRequest
  });
  if (conversionHistoryTab) tabs.push(conversionHistoryTab);

  const productLayersTab = buildProductLayersTab({
    shouldShowPage,
    apiRequest: ctx.apiRequest,
    mapSettings: ctx.mapSettings,
    setMapSettings: ctx.setMapSettings,
    handleSaveMapSettings: ctx.handleSaveMapSettings,
    mapSettingsMsg: ctx.mapSettingsMsg
  });
  if (productLayersTab) tabs.push(productLayersTab);

  const systemSettingsTab = buildSystemSettingsTab({
    shouldShowPage,
    apiRequest: ctx.apiRequest,
    handleSaveSystemSettings: ctx.handleSaveSystemSettings,
    updateSystemSettings: ctx.updateSystemSettings,
    systemSettings: ctx.systemSettings,
    commandPwd: ctx.commandPwd,
    newPwd: ctx.newPwd,
    setNewPwd: ctx.setNewPwd,
    pwdMsg: ctx.pwdMsg,
    showCommandPwd: ctx.showCommandPwd,
    setShowCommandPwd: ctx.setShowCommandPwd,
    handleSavePwd: ctx.handleSavePwd,
    mapSettings: ctx.mapSettings,
    setMapSettings: ctx.setMapSettings,
    handleSaveMapSettings: ctx.handleSaveMapSettings,
    handleCleanupLocationData: ctx.handleCleanupLocationData,
    mapSettingsMsg: ctx.mapSettingsMsg,
    trackStats: ctx.trackStats,
    trackSettings: ctx.trackSettings,
    setTrackSettings: ctx.setTrackSettings,
    saveTrackSettings: ctx.saveTrackSettings,
    trackSettingsLoading: ctx.trackSettingsLoading,
    cleanupTrackData: ctx.cleanupTrackData,
    trackSettingsMsg: ctx.trackSettingsMsg,
    trackSessions: ctx.trackSessions,
    homepageSettingsTab: ctx.homepageSettingsTab,
    setHomepageSettingsTab: ctx.setHomepageSettingsTab,
    fetchDbSchema: ctx.fetchDbSchema,
    schemaLoading: ctx.schemaLoading,
    schemaError: ctx.schemaError,
    dbSchema: ctx.dbSchema,
    auditLogs: ctx.auditLogs,
    auditLogsLoading: ctx.auditLogsLoading,
    fetchAuditLogs: ctx.fetchAuditLogs,
    auditSetupMessage: ctx.auditSetupMessage
  });
  if (systemSettingsTab) tabs.push(systemSettingsTab);

  return tabs;
}
